import { ReactNode } from "react";
import styles from "./table-display-title.module.scss";

const TableDisplayTitle = ({ children }: { children: ReactNode }) => (
  <div className={styles.displayTitle}>{children}</div>
);

export default TableDisplayTitle;
